// !Note: revenuecat subscription API return `productId` whose value is NOT app/play store product ID but Revenuecat productID.
// Which is why here as a hack we have put the Revcat productIDs that associate with family plan.

import type { PurchasesEntitlementInfo } from '@inkitt/contracts-common';

// We should either find a automated way to convert revcatProductId to app/play store productId or some other way to not have to manually put list of revcat productIDs here
const REVENUECAT_FAMILY_PLAN_PRODUCT_IDS = [
  // iOS - com.colt.unlimited.ab_family_plan.family.p1y
  'prodf5b46ba402',

  // Android - com.colt.unlimited.ab_family_plan:family-p1y
  'prod510fde3d8f',

  // Android - com.colt.unlimited.ab_family_plan.family:family-p1y
  'prodac038b1d02',

  // iOS - com.colt.unlimited.yearly.family.baseline
  'prod46f8844ea6',

  // Android - com.colt.unlimited.yearly.family:p1y
  'prod73c36263bd',

  // International pricing alignment
  'prod3cb00dcbe0', // iOS - com.colt.unlimited.family_intl.baseline.p1y
  'prodc83add5c0b', // Android - com.colt.unlimited.family_intl.baseline:p1y

  // Organic Free Trial
  'prod1b9a6fa04e', // iOS - com.colt.unlimited.with_intro_offer.family.p1y
  'prod6dcc6ca469', // Android - com.colt.unlimited.yearly.family:p1y-organic
];

export const familyPlanUtils = {
  isFamilyPlanProductId(productId: string) {
    // iOS Example: `com.........family.p1y`
    // Android Example: `com........family:p1y` or `com........family:p1y` or `com........family:family-p1y`
    return productId.includes('.family') || productId.includes(':family');
  },
  isFamilyPlanRevcatProductId(productId: string) {
    return REVENUECAT_FAMILY_PLAN_PRODUCT_IDS.includes(productId);
  },

  isFamilyPlanEntitlement(entitlement: PurchasesEntitlementInfo) {
    const purchasedProductId =
      entitlement.productIdentifier +
      (entitlement.productPlanIdentifier ? `:${entitlement.productPlanIdentifier}` : '');
    return this.isFamilyPlanProductId(purchasedProductId) || this.isFamilyPlanRevcatProductId(purchasedProductId);
  },
};
